import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  inject,
  viewChild,
} from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Models, propsToFilter } from '../../../../models/global.models';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, debounceTime, takeUntil, tap } from 'rxjs';
import { InputGroup } from 'primeng/inputgroup';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { Button, ButtonDirective } from 'primeng/button';
import { Listbox } from 'primeng/listbox';
import { PrimeTemplate } from 'primeng/api';
import { CmgHighlightDirective } from '../../../../../../../../libs/ui/src/lib/directives/cmg-highlight.directive';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-expand-search-modal',
  templateUrl: './expand-search-modal.component.html',
  styleUrls: ['./expand-search-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputGroup,
    IconField,
    InputIcon,
    ReactiveFormsModule,
    InputText,
    InputGroupAddon,
    Button,
    Listbox,
    PrimeTemplate,
    CmgHighlightDirective,
    ButtonDirective,
    DatePipe,
  ],
})
export class ExpandSearchModalComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly _config = inject(DynamicDialogConfig);
  private readonly _cdRef = inject(ChangeDetectorRef);

  readonly searchControlElement = viewChild('searchControlElement', { read: ElementRef });

  searchResults: Models.GlobalSearchResult[];
  searchControl = new FormControl('');

  get searchTerm() {
    return this.searchControl?.value;
  }

  private _destroy$ = new Subject();

  private _searchResultCache: Models.GlobalSearchResult[];

  ngOnInit() {
    this.searchResults = this._config.data.searchResults;
    this._searchResultCache = JSON.parse(JSON.stringify(this._config.data.searchResults));
    this.searchControl.valueChanges
      .pipe(
        takeUntil(this._destroy$),
        debounceTime(500),
        tap((value) => {
          this._filterResults(value);
        }),
      )
      .subscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const searchControlElement = this.searchControlElement();
      if (searchControlElement) {
        searchControlElement.nativeElement?.focus();
      }
    }, 500);
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  private _filterResults(listboxSearchTerm: string) {
    this.searchResults = this._searchResultCache?.filter((result) => {
      return propsToFilter.find((prop) => {
        let found = false;

        if (Array.isArray(result[prop])) {
          found = result[prop].some((x) => x?.toLowerCase()?.includes(listboxSearchTerm?.toLowerCase()));
        } else {
          found = result[prop]?.toLowerCase()?.includes(listboxSearchTerm?.toLowerCase());
        }

        return found;
      });
    });
    this._cdRef.detectChanges();
  }
}
